export default __webpack_public_path__ + "static/media/no-trades-light.4c01e8f7.png";